var Component = require('./../../Component');
var $ = require('jQuery');
//var stat = require('./../../../global/stat');
//var StatPoint = require('./../../../constant/StatPoint');
var util = require('../../../global/utils');
var html2Text = require('../../../utils/html2Text');
var AppPosition = require('./../../../constant/AppPosition');
var gdic = require('./../../../global/globalDic');
var IEVersion = util.IEVersion()

var Editor = function (options) {
  Component.call(this, options);
  (function (self) {
    //enter键发送消息
    self._element.keydown(function (e) {
      if (self._options._entrusted && self._options._entrust_keycodes && self._options._entrust_keycodes.length && self._options._entrust_keycodes.indexOf(e.keyCode) >= 0) {
        self.keyboard_output(e);
        e.stopPropagation();
        e.preventDefault();
        return;
      }
      if (e.keyCode === 13) {
        if (e.ctrlKey) {
          var len = self.get().msg.length;
          if (len > 3 && self.get().msg.substring(len - 4) == '<br>') {
            self.update("<br>", {
              need_html_2: true
            });
          } else {
             //判断浏览器
             var userAgent = navigator.userAgent;
             var isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(userAgent);
        
             if (userAgent.indexOf("Firefox") > -1 || IEVersion!== -1 || isSafari) { //判断是否Firefox浏览器\IE\safari浏览器
                 self.update("<br>", {
                  need_html_2: true
                });
             }else{
                 self.update("<br><br>", {
                  need_html_2: true
                });
             }
          }
          self.focus();
        } else {
          e.stopPropagation();
          e.preventDefault();
          if (self.get().msg.length != 0) {
            //埋点统计（回车发送消息）
            //stat.report(StatPoint.msg_send);
            var position = gdic.get('position');
            //发送消息的埋点统计：center_session_click为事件ID=13,normal_session_click事件ID=12
            var id = position == AppPosition.CENTER ? 13 : 12;
            if(window.WMDA_REPORT){
              window.WMDA_REPORT('custom',{event_id:id})
          }
          }
          self._input.send();
        }
      } else if (e.keyCode == 38 || e.keyCode == 40) {
        if (self.get().msg.length != 0) {
          e.stopPropagation();
        }
      } else if (e.keyCode == 8) {
        if (!window.getSelection) {
          return;
        }
        var selection = window.getSelection();
        if (!selection.isCollapsed || !selection.rangeCount) {
          return;
        }

        var curRange = selection.getRangeAt(selection.rangeCount - 1);
        setTimeout(function () {
          self.inputChange(self.get().msg);
        }, 0);
        if (curRange.commonAncestorContainer.nodeType == 3 && curRange.startOffset >= 0) {
          // we are in child selection. The characters of the text node is being deleted
          return;
        }

        var range = document.createRange();
        if (selection.anchorNode != this) {
          // selection is in character mode. expand it to the whole editable field
          range.selectNodeContents(this);
          range.setEndBefore(selection.anchorNode);
        } else if (selection.anchorOffset > 0) {
          range.setEnd(this, selection.anchorOffset);
        } else {
          // reached the beginning of editable field
          return;
        }
        range.setStart(this, range.endOffset - 1);


        var previousNode = range.cloneContents().lastChild;
        if (previousNode && previousNode.contentEditable == 'false') {
          // this is some rich content, e.g. smile. We should help the user to delete it
          range.deleteContents();
          e.preventDefault();
        }
      } else {
        setTimeout(function () {
          self.inputChange(self.get().msg);
        }, 0);
      }
    });
    

    self._element.keyup(function (e) {
      //var length = self._element.find('.textarea').val().length;
      if(self.get().msg === '<br>'){
        self.clear();
      }
      var value = self.emotionToText(self.get().msg);
      var length = value.length;
      if(length === 0){
        self._input.hideSend();
      }else{
        self._input.showSend();
      }
      var maxInputLength = self._input.getMaxInputLength();
      if (length > maxInputLength) {
        var overflowLen = length - maxInputLength;
        var counts = Math.ceil(length / maxInputLength);
        var txt = '已超出' + overflowLen + '个字，将分为' + counts + '条发出';
        self._input.showNotice(txt);
      } else {
        if ([13, 17].indexOf(e.keyCode) === -1) {
          self._input.hideNotice();
        }
      }
    });

    self._element.click(function () {
      self._element[0].focus();
    });

    //监听拖拽和粘贴图片事件
    /* 拖动完成后触发*/
    /*self._element.on('dragover',  function(e) {
     e.preventDefault();
     });
     self._element.on('drop', function(e) {
     e.preventDefault();
     var fs;
     if (window.dataTransfer) { // IE
     fs = window.dataTransfer.files;
     } else {
     fs = e.originalEvent.dataTransfer.files;//e.clipboardData.getData('text/plain');
     }
     if (fs.length === 0) {
     return;
     }
     self.imgSend(fs[0]);
     });*/
    self._element.on('paste', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var data = util.getClipboardData(e);
      if (!data) {
        self._input.showNotice('当前浏览器暂不支持粘贴!');
        return;
      }

      if (data.type === 'text') {
        //self.update(text);
        console.log(data.content, 'data.content');
        util.insertHtmlAtCaret(html2Text(data.content));
        setTimeout(function () {
          self.inputChange(self.get().msg);
        }, 0);
      }
      if (data.type === 'file') {
        //图片预览
        self._input.previewImage(data.content);
      }
    });
  })(this);
};
Editor.prototype = Object.create(Component.prototype);
Editor.prototype.clear = function () {
};
Editor.prototype.get = function () {
};
Editor.prototype.update = function (value) {
};
Editor.prototype.focus = function () {
  var self = this;
  util.setEndOfContenteditable(self._element[0]);
  self._element[0].focus();
};
Editor.prototype.setInput = function (input) {
  return this._input = input;
};
Editor.prototype.emotionToText = function (value) {
  //将里面的表情img替换成文本
  var emotiontitle = [];
  //匹配图片（g表示匹配所有结果i表示区分大小写）
  var emotionReg = /<img[^<]*(data=[\'\"]?([^\'\"]*)[\'\"]?).*?[^<]*>/gi;
  var arr = value.match(emotionReg);
  if (arr) {
    for (var i = 0; i < arr.length; i++) {
      if (arr[i].match(emotionReg)) {
        emotiontitle[i] = arr[i].match(/data=[\'\"]?([^\'\"]*)[\'\"]?/i)[1];
      }
    }
    var index = -1;
    value = value.replace(emotionReg, function (item) {
      index++;
      return item.replace(emotionReg, emotiontitle[index]);
    });
  }
  return value;
};

Editor.prototype.inputChange = function (value) {
};

Editor.prototype.keyboardEntrust = function () {

};

Editor.prototype.keyboardEntrust = function () {
  this._options._entrusted = true;
};

Editor.prototype.keyboardUnEntrust = function () {
  this._options._entrusted = false;
};

Editor.prototype.keyboard_output = function (e) {

};

module.exports = Editor;
